import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { DATE_FORMAT } from "helpers/common";
import { FadeLoader } from "react-spinners";
import { purchaseEnergyListDetailsApi } from "store/actions";

export default function EnergyPurchaseHistoryModal({
  show,
  handleClose,
  title,
  id,
}) {
  const { loading } = useSelector(({ EnergyPackage }) => EnergyPackage);

  const [data, setData] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id]);

  const fetchData = async () => {
    dispatch(
      purchaseEnergyListDetailsApi({
        data: { _id: id },
        callBack: async (err, response) => {
          const game = response?.data;
          if (game?._id) {
            try {
              setData(game);
            } catch (err) {
              console.error("error inside try useEffetc", err);
            }
          }
        },
      }),
    );
  };

  const status = {
    active: "Active",
    completed: "Completed",
    ended: "Ended",
  };

  return loading ? (
    <div className="main-loader">
      <FadeLoader size={1000} />
    </div>
  ) : (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
    >
      <Modal.Header className="py-3 text-dark" closeButton>
        {/* <Modal.Title className="fw-bold text-dark">{title}</Modal.Title> */}
      </Modal.Header>

      <Modal.Body>
        <>
          <section className="section">
            <div className="section-header">
              <h1>Energy Purchase History Details</h1>
            </div>

            <div className="section-body">
              <div className="card">
                <Row>
                  <Col lg="12" className="my-2 px-4">
                    {/* <h4 className="text-primary">Match Details</h4> */}
                    <ul className="list-unstyled ps-0 mb-0 mt-3 row">
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="mb-0">
                          {" "}
                          <span className="font-weight-bold">PurchaseID</span>
                        </p>
                        <p className="mb-0"> {data?.purchaseID || "--"} </p>
                      </li>
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="mb-0 font-weight-bold">
                          Telegram Username
                        </p>
                        <p className="mb-0">
                          {data?.userDetails?.telegram_username || "--"}
                        </p>
                      </li>

                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="mb-0 font-weight-bold">First Name</p>
                        <p className="mb-0">
                          {data?.userDetails?.first_name || "--"}
                        </p>
                      </li>

                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="mb-0 font-weight-bold">Last Name</p>
                        <p className="mb-0">
                          {data?.userDetails?.last_name || "--"}
                        </p>
                      </li>

                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="mb-0 font-weight-bold">Email</p>
                        <p className="mb-0">
                          {data?.userDetails?.email || "--"}
                        </p>
                      </li>

                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="mb-0 font-weight-bold">Energy Package</p>
                        <p className="mb-0">
                          {data?.energyPackageDetails?.name || "Custom"}
                        </p>
                      </li>

                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="mb-0 font-weight-bold">Payment Type</p>
                        <p className="mb-0">
                          {data?.paymentType
                            ? data.paymentType.toUpperCase()
                            : "--"}
                        </p>
                      </li>

                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="mb-0 font-weight-bold">Energy</p>
                        <p className="mb-0">{data?.energy ?? 0}</p>
                      </li>

                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="mb-0 font-weight-bold">Amount</p>
                        <p className="mb-0">
                          {Number(data?.amount ?? 0).toFixed(2)}{" "}
                          {(data?.currencySymbol || "").toUpperCase()}
                        </p>
                      </li>

                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="mb-0 font-weight-bold">
                          Previous Energy Balance
                        </p>
                        <p className="mb-0">{data?.prevEnergyBalance ?? 0}</p>
                      </li>

                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="mb-0 font-weight-bold">
                          New Energy Balance
                        </p>
                        <p className="mb-0">{data?.newEnergyBalance ?? 0}</p>
                      </li>

                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="mb-0 font-weight-bold">Status</p>
                        <p className="mb-0">
                          {" "}
                          {data?.paymentStatus
                            ? data.paymentStatus.toUpperCase()
                            : "--"}
                        </p>
                      </li>
                      {data?.paymentType !== "crypto" && (
                        <>
                          <li className="col-lg-4 col-sm-6 my-2">
                            <p className="mb-0 font-weight-bold">Message</p>

                            <p
                              className="mb-0"
                              title={data?.message}
                              style={{
                                maxWidth: "100%",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                cursor: data?.message ? "pointer" : "default",
                                transition: "all 0.2s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.whiteSpace = "normal";
                                e.currentTarget.style.wordBreak = "break-word";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.whiteSpace = "nowrap";
                                e.currentTarget.style.wordBreak = "normal";
                              }}
                            >
                              {data?.message || "--"}
                            </p>
                          </li>

                          <li className="col-lg-4 col-sm-6 my-2">
                            <p className="mb-0 font-weight-bold">Order ID</p>
                            <p className="mb-0">{data?.order_id || "--"}</p>
                          </li>

                          <li className="col-lg-4 col-sm-6 my-2">
                            <p className="mb-0 font-weight-bold">
                              Order Status
                            </p>
                            <p className="mb-0">
                              {data?.order_status
                                ? data.order_status.toUpperCase()
                                : "--"}
                            </p>
                          </li>

                          <li className="col-lg-4 col-sm-6 my-2">
                            <p className="mb-0 font-weight-bold">
                              Payment Method
                            </p>
                            <p className="mb-0">
                              {data?.payment_method
                                ? data.payment_method.toUpperCase()
                                : "--"}
                            </p>
                          </li>

                          <li className="col-lg-4 col-sm-6 my-2">
                            <p className="mb-0 font-weight-bold">
                              Webhook Confirmation
                            </p>
                            <p className="mb-0">
                              {data?.webhookConfirmation
                                ? data.webhookConfirmation.toUpperCase()
                                : "--"}
                            </p>
                          </li>
                        </>
                      )}

                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="mb-0 font-weight-bold">Created At</p>
                        <p className="mb-0">
                          {data?.date_created_utc
                            ? DATE_FORMAT(data.date_created_utc)
                            : "--"}
                        </p>
                      </li>

                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="mb-0 font-weight-bold">Completed At</p>
                        <p className="mb-0">
                          {data?.transactionCompletedAt
                            ? DATE_FORMAT(data.transactionCompletedAt)
                            : "--"}
                        </p>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </div>
            </div>
          </section>
        </>
      </Modal.Body>
    </Modal>
  );
}
